var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { cacheHelper } from 'utils/cache-helper';
import { apiService } from './api-service';
export var LookupType;
(function (LookupType) {
    LookupType[LookupType["ProductLine"] = 0] = "ProductLine";
    LookupType[LookupType["DiscountCode"] = 1] = "DiscountCode";
    LookupType[LookupType["ProductFunctionCode"] = 2] = "ProductFunctionCode";
    LookupType[LookupType["WeightClassCode"] = 3] = "WeightClassCode";
    LookupType[LookupType["SalesbrandCode"] = 4] = "SalesbrandCode";
    LookupType[LookupType["CategoryCode"] = 5] = "CategoryCode";
    LookupType[LookupType["SalesproductLineCode"] = 6] = "SalesproductLineCode";
    LookupType[LookupType["TypeCode"] = 7] = "TypeCode";
    LookupType[LookupType["SubCategoryCode"] = 8] = "SubCategoryCode";
})(LookupType || (LookupType = {}));
export function lookupByPrefix(field, value, size) {
    if (size === void 0) { size = 1; }
    return __awaiter(this, void 0, Promise, function () {
        var key, cacheRsp, columnName, rsp, values, outputRsp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    key = "".concat(field, "_").concat(value, "_").concat(size);
                    cacheRsp = cacheHelper.getCache(key);
                    if (cacheRsp) {
                        cacheRsp;
                    }
                    columnName = '';
                    switch (field) {
                        case LookupType.ProductLine:
                            columnName = 'line.code';
                            break;
                        case LookupType.DiscountCode:
                            columnName = 'discountCode';
                            break;
                        case LookupType.ProductFunctionCode:
                            columnName = 'productFunctionCode';
                            break;
                        case LookupType.WeightClassCode:
                            columnName = 'weightClassCode';
                            break;
                        case LookupType.SalesbrandCode:
                            columnName = 'baseProducts.brandCode';
                            break;
                        case LookupType.CategoryCode:
                            columnName = 'baseProducts.categoryCode';
                            break;
                        case LookupType.SalesproductLineCode:
                            columnName = 'baseProducts.productLineCode';
                            break;
                        case LookupType.TypeCode:
                            columnName = 'baseProducts.typeCode';
                            break;
                        case LookupType.SubCategoryCode:
                            columnName = 'baseProducts.subCategoryCode';
                            break;
                        default:
                            break;
                    }
                    return [4 /*yield*/, apiService.post('search?indexName=product-version', {
                            size: size,
                            _source: [columnName],
                            query: {
                                bool: {
                                    filter: [
                                        {
                                            term: (_a = {},
                                                _a[columnName] = value,
                                                _a),
                                        },
                                    ],
                                },
                            },
                        })];
                case 1:
                    rsp = _b.sent();
                    values = [];
                    switch (field) {
                        case LookupType.ProductLine:
                            values = rsp.body.data.map(function (el) { var _a; return (_a = el.body.line) === null || _a === void 0 ? void 0 : _a.code; });
                            break;
                        case LookupType.DiscountCode:
                            values = rsp.body.data.map(function (el) { return el.body.discountCode; });
                            break;
                        case LookupType.ProductFunctionCode:
                            values = rsp.body.data.map(function (el) { return el.body.productFunctionCode; });
                            break;
                        case LookupType.WeightClassCode:
                            values = rsp.body.data.map(function (el) { return el.body.weightClassCode; });
                            break;
                        case LookupType.SalesbrandCode:
                            values = rsp.body.data.map(function (el) { var _a, _b; return (_b = (_a = el.body.baseProducts) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.brandCode; });
                            break;
                        case LookupType.CategoryCode:
                            values = rsp.body.data.map(function (el) { var _a, _b; return (_b = (_a = el.body.baseProducts) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.categoryCode; });
                            break;
                        case LookupType.SubCategoryCode:
                            values = rsp.body.data.map(function (el) { var _a, _b; return (_b = (_a = el.body.baseProducts) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.subCategoryCode; });
                            break;
                        case LookupType.TypeCode:
                            values = rsp.body.data.map(function (el) { var _a, _b; return (_b = (_a = el.body.baseProducts) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.typeCode; });
                            break;
                        case LookupType.SalesproductLineCode:
                            values = rsp.body.data.map(function (el) { var _a, _b; return (_b = (_a = el.body.baseProducts) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.productLineCode; });
                            break;
                        default:
                            break;
                    }
                    outputRsp = { values: values, status: rsp.status };
                    cacheHelper.setCache(key, outputRsp);
                    return [2 /*return*/, outputRsp];
            }
        });
    });
}
